'use client';
import { caseStudiesRoutingConfig, generateRouting, journalRoutingConfig, searchClient } from '@fm-nx/algolia';
import { Configure } from 'react-instantsearch-core';
import { InstantSearchNext } from 'react-instantsearch-nextjs';
import SearchCurrentRefinements from '../search-current-refinements/search-current-refinements';
import SearchFilters from '../search-filters/search-filters';
import SearchHitsCaseStudies from '../search-hits-case-studies/search-hits-case-studies';
import SearchHitsJournal from '../search-hits-journal/search-hits-journal';
import SearchHitsViewed from '../search-hits-viewed/search-hits-viewed';
import SearchInsightsMiddleware from '../search-insights-middleware/search-insights-middleware';
import SearchPagination from '../search-pagination/search-pagination';

import type { TopicConfig } from './routing-config';

export interface SearchContainerProps {
    index: 'journal' | 'case_studies' | 'everything';
    topicConfigs?: Record<string, TopicConfig>;
    baseTitle?: string;
    excludeId?: string;
}

export function SearchContainer(props: SearchContainerProps) {
    const index = `${process.env['NEXT_PUBLIC_ALGOLIA_INDEX_PREFIX'] || ''}${props.index}`;

    // Determine routing config based on index
    let routing;
    if (props.index === 'journal') {
        routing = generateRouting<'about/journal'>({ ...journalRoutingConfig, index });
    } else if (props.index === 'case_studies') {
        routing = generateRouting<'case-studies'>({ ...caseStudiesRoutingConfig, index });
    } else {
        routing = true;
    }

    return (
        <div className="container-full">
            <InstantSearchNext
                searchClient={searchClient}
                indexName={index}
                routing={routing}
                future={{ preserveSharedStateOnUnmount: true }}
                insights
            >
                <Configure filters={`${props.excludeId ? `NOT objectID:${props.excludeId}` : ''}`} />
                <SearchInsightsMiddleware />
                <SearchHitsViewed />
                <div data-insights-index={index}>
                    <div className="my-8">
                        <SearchFilters index={index} />
                        <div className="mt-8">
                            <SearchCurrentRefinements />
                        </div>
                    </div>

                    {index.includes('case_studies') && <SearchHitsCaseStudies />}
                    {index.includes('journal') && <SearchHitsJournal />}
                </div>
                <SearchPagination />
            </InstantSearchNext>
        </div>
    );
}
